import React from 'react';
import { Typography } from '../../../../../electrons';
import { useStyles } from './InputTitle.styles';
export function InputTitle({ className, title, required, endAdornment, }) {
    const requiredMark = required ? ' *' : '';
    const classes = useStyles();
    return title || endAdornment ? (React.createElement("div", { className: classes.container },
        React.createElement(Typography, { className: className, variant: "subtitle1" }, title + requiredMark),
        endAdornment)) : null;
}
//# sourceMappingURL=InputTitle.js.map